import { render, staticRenderFns } from "./WhyGamefoundView.vue?vue&type=template&id=4ff5c3ef"
import script from "./WhyGamefoundView.vue?vue&type=script&lang=js"
export * from "./WhyGamefoundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports